import { SNItem } from '../models/snitem';

export class SNUser extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNUser';
    }

    get editmode() {
        return true;
    }

    get firstname() {
        return this.getProperty('Firstname');
    }

    get lastname() {
        return this.getProperty('Lastname');
    }

    public clone(): any {
        return new SNUser();
    }
}
